import { useAuth } from "@clerk/react";
import { useCallback } from "react";
import { http } from "@/lib/api";

export const LANG_NAMES = { es: "Español", fr: "Français", zh: "中文", hi: "हिन्दी", ar: "العربية", pt: "Português", bn: "বাংলা", ru: "Русский" };

export const useAuthedHttp = () => {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data) => {
    const headers = { Authorization: `Bearer ${await getToken()}` };
    const res = method === "get" || method === "delete" ? await http[method](url, { headers }) : await http[method](url, data, { headers });
    return res.data;
  }, [getToken]);
};

export const errMsg = (e, fallback) => e?.response?.data?.detail || fallback;
